import { useState } from "react";
import { PhoneCall } from "lucide-react";
import { scrollToSection } from "../lib/scroll";
import { LegalDialog } from "./LegalDialog";

const NAV = [
    { label: "Über mich", href: "#ueber-mich" },
    { label: "Beratung", href: "#beratung" },
    { label: "Ablauf", href: "#ablauf" },
    { label: "Preise", href: "#preise" },
    { label: "Kontakt", href: "#kontakt" },
];

export const Footer = () => {
    const [legal, setLegal] = useState(null);
    return (
    <footer data-testid="site-footer" className="bg-[#2B2825] text-[#B8AFA2] pt-20 pb-10">
        <LegalDialog type={legal} onClose={() => setLegal(null)} />
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <div
                data-testid="footer-krisen-bar"
                className="border border-[#4A453F] px-7 py-6 mb-16 flex flex-col sm:flex-row sm:items-start gap-5 sm:gap-14"
            >
                <div className="flex items-center gap-3 sm:pt-0.5">
                    <PhoneCall size={17} strokeWidth={1.5} className="text-[#CFC7B8] shrink-0" />
                    <p className="font-serif text-lg text-[#FAF8F5]">In einer akuten Krise?</p>
                </div>
                <div className="font-sans text-sm font-light grid grid-cols-[1fr_auto] gap-x-8 gap-y-2 max-w-xs w-full">
                    <span>Die Dargebotene Hand</span>
                    <a href="tel:143" className="font-medium text-[#FAF8F5] hover:underline text-right">143</a>
                    <span>Pro Juventute (Jugendliche)</span>
                    <a href="tel:147" className="font-medium text-[#FAF8F5] hover:underline text-right">147</a>
                    <span>Sanitätsnotruf</span>
                    <a href="tel:144" className="font-medium text-[#FAF8F5] hover:underline text-right">144</a>
                    <span>Polizeinotruf</span>
                    <a href="tel:117" className="font-medium text-[#FAF8F5] hover:underline text-right">117</a>
                </div>
            </div>

            <div className="grid md:grid-cols-3 gap-12">
                <div>
                    <p data-testid="footer-brand" className="font-serif text-2xl text-[#FAF8F5]">
                        Fjona Gerber
                    </p>
                    <p className="font-sans text-[10px] font-medium tracking-[0.3em] uppercase text-[#8C8275] mt-2">
                        Psychosoziale Beratung
                    </p>
                </div>

                <div>
                    <p className="font-sans text-[10px] font-medium tracking-[0.3em] uppercase text-[#8C8275] mb-5">Navigation</p>
                    <nav className="grid grid-cols-2 gap-3">
                        {NAV.map((n) => (
                            <button
                                key={n.href}
                                data-testid={`footer-link-${n.href.replace("#", "")}`}
                                onClick={() => scrollToSection(n.href)}
                                className="text-left font-sans text-sm font-light hover:text-[#FAF8F5] transition-colors"
                            >
                                {n.label}
                            </button>
                        ))}
                    </nav>
                </div>

                <div>
                    <p className="font-sans text-[10px] font-medium tracking-[0.3em] uppercase text-[#8C8275] mb-5">Rechtliches</p>
                    <div className="space-y-3">
                        <button onClick={() => setLegal("impressum")} data-testid="footer-link-impressum" className="block font-sans text-sm font-light hover:text-[#FAF8F5] transition-colors">
                            Impressum
                        </button>
                        <button onClick={() => setLegal("datenschutz")} data-testid="footer-link-datenschutz" className="block font-sans text-sm font-light hover:text-[#FAF8F5] transition-colors">
                            Datenschutzerklärung
                        </button>
                    </div>
                    <p className="mt-7 font-sans text-xs font-light leading-relaxed text-[#8C8275]">
                        Hinweis: Dieses Angebot ist eine psychosoziale Beratung und keine Psychotherapie
                        oder medizinische Behandlung.
                    </p>
                </div>
            </div>

            <div className="border-t border-[#4A453F] mt-14 pt-7">
                <p className="font-sans text-xs font-light text-[#8C8275]">© 2026 Fjona Gerber – Psychosoziale Beratung</p>
            </div>
        </div>
    </footer>
    );
};
